export default {"src":"/_next/static/media/government.16adf89e.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};